import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Case from '../../interfaces/case';

interface GridSelectedCaseState {
    gridSelectedCase: Case | null,
}

const initialState: GridSelectedCaseState = {
    gridSelectedCase: null
}

export const gridSelectedCaseSlice = createSlice({
    name: 'gridSelectedCase',
    initialState,
    reducers: {
        loadGridSelectedCase: (state, action: PayloadAction<Case | null>) => {
            state.gridSelectedCase = action.payload
        }
    }
});

export const { loadGridSelectedCase } = gridSelectedCaseSlice.actions;

export default gridSelectedCaseSlice.reducer;